/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['@media (min-width: 600px) {\n  td-dialog[_ngcontent-%COMP%] {\n    width: 400px; } }\n\n@media (max-width: 599px) {\n  td-dialog[_ngcontent-%COMP%] {\n    width: 250px; } }'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiQzovVXNlcnMvb3Jpb24vUHJvamVjdHMvc2ltcGxpY2l0eUVuZ2luZS92YWxtdXN0L3ZhbG11c3RmZS9ub2RlX21vZHVsZXMvQGNvdmFsZW50L2NvcmUvZGlhbG9ncy9wcm9tcHQtZGlhbG9nL3Byb21wdC1kaWFsb2cuY29tcG9uZW50LmNzcy5zaGltLm5nc3R5bGUudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9DOi9Vc2Vycy9vcmlvbi9Qcm9qZWN0cy9zaW1wbGljaXR5RW5naW5lL3ZhbG11c3QvdmFsbXVzdGZlL25vZGVfbW9kdWxlcy9AY292YWxlbnQvY29yZS9kaWFsb2dzL3Byb21wdC1kaWFsb2cvcHJvbXB0LWRpYWxvZy5jb21wb25lbnQuY3NzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/$$_gendir/~/@covalent/core/dialogs/prompt-dialog/prompt-dialog.component.css.shim.ngstyle.ts